import { render, staticRenderFns } from "./merge_groups.vue?vue&type=template&id=7def5ec4&scoped=true&"
import script from "./merge_groups.vue?vue&type=script&lang=ts&"
export * from "./merge_groups.vue?vue&type=script&lang=ts&"
import style0 from "./merge_groups.vue?vue&type=style&index=0&id=7def5ec4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7def5ec4",
  null
  
)

export default component.exports